import { render, staticRenderFns } from "./content_mentions.vue?vue&type=template&id=0909a900&scoped=true"
import script from "./content_mentions.vue?vue&type=script&lang=js"
export * from "./content_mentions.vue?vue&type=script&lang=js"
import style0 from "./content_mentions.vue?vue&type=style&index=0&id=0909a900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909a900",
  null
  
)

export default component.exports